export default "__VITE_ASSET__BR3FAssd__"